module.exports = __webpack_public_path__ + "static/media/snow.04c556c8.jpeg";